import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const PopperMenu = styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--padding-5) var(--padding-2);
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	z-index: var(--z-index-2);
	box-shadow: var(--container-box-shadow);
	overflow: auto;
	gap: 2rem;
	max-height: 70vh;
	min-width: 24rem;
	width: 30vw;
`;

export const PopperMenuItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	padding-top: var(--margin-2);
	gap: var(--margin-4);

	@media ${Breakpoints.mobile} {
		padding: 0 var(--padding-2) var(--padding-5) var(--padding-2);
	}
`;

export const ChartContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	padding: 2rem 0;
`;

export const BarChartContainer = styled.div`
	width: 30%;
	max-width: 100rem;
	flex: 1;
	background-color: var(--white);
	padding: 1rem;
	border-radius: var(--medium-border-radius);

	@media ${Breakpoints.desktop} {
		width: 45%;
		max-width: 55rem;
	}
	@media ${Breakpoints.tablet} {
		width: 100%;
		max-width: unset;
	}
`;

export const DCBarChartContainer = styled.div`
	width: 100%;
	height: 40rem;
`;

export const SummaryCardWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;

export const SummaryCardContainer = styled.div`
	display: flex;
	justify-content: space-around;
	width: 60%;
	padding: 3rem 0;
	max-width: 100rem;
	background-color: var(--white);
	border-radius: var(--small-border-radius);
	@media ${Breakpoints.desktop} {
		width: 80%;
	}
	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const SummaryCardArea = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	.card-number-text {
		display: flex;
		gap: 0.5rem;
		justify-content: center;
		align-items: baseline;
		font-size: 3.5rem;
	}
	.card-percentage-text {
		font-size: 2rem;
	}
	&.center {
		align-items: center;
	}
`;
